import React, { useEffect, useMemo, useRef } from "react";
import Grid from "@mui/material/Grid";
import ColumnGroupingTable from "../../../table/ColumnGroupingTable.component";

const NiiInputTable = ({
  NIIData,
  setNiiInputTableData,
  setNiiInputTablecolumn,
} = {}) => {
  const columns = useMemo(() => {
    const dataRowWithDatas = NIIData?.find(
      (item) => item?.datas && Object.keys(item.datas).length > 0,
    );

    const dynamicColumns = dataRowWithDatas?.datas
      ? Object.keys(dataRowWithDatas.datas).map((key) => ({
          id: key,
          label: key,
          minWidth: 78,
          align: "right",
        }))
      : [];

    return [
      { id: "type", label: "Type", minWidth: 230, align: "left" },
      { id: "cashflow", label: "Cashflow", minWidth: 200, align: "left" },
      ...dynamicColumns,
    ];
  }, [NIIData]);

  const applyNegativeStyles = (rowData, monthColumns) => {
    const dynamicStyles = {};
    let hasNegative = false;

    monthColumns.forEach((month) => {
      const value = rowData[month];

      if (typeof value === "number" && (value < 0 || Object.is(value, -0))) {
        dynamicStyles[month] = { color: "red" };
        hasNegative = true;
      }
    });

    return hasNegative ? { dynamicCellStyles: dynamicStyles } : {};
  };

  const datas = useMemo(() => {
    if (!NIIData || NIIData.length === 0) return [];

    const flattenedData = [];

    const monthColumns = columns.slice(2).map((col) => col.id);

    NIIData.forEach((typeGroup) => {
      const type = typeGroup?.reportingAccountName;
      const rowSpanLength = typeGroup?.subAccounts?.length;

      typeGroup?.subAccounts?.forEach((item, index) => {
        const dynamicStyles = applyNegativeStyles(item.datas, monthColumns);

        const newRow = {
          type: type,
          cashflow: item?.reportingAccountName,
          ...item.datas,
          rowSpan: index === 0 ? rowSpanLength : 0,
          ...dynamicStyles,
        };
        flattenedData.push(newRow);
      });
    });

    return flattenedData;
  }, [NIIData, columns]);

  const prevColumnsRef = useRef();
  const prevDatasRef = useRef();

  useEffect(() => {
    const columnsChanged =
      JSON.stringify(prevColumnsRef.current) !== JSON.stringify(columns);
    const datasChanged =
      JSON.stringify(prevDatasRef.current) !== JSON.stringify(datas);

    if (columnsChanged) {
      setNiiInputTablecolumn(columns);
      prevColumnsRef.current = columns;
    }
    if (datasChanged) {
      setNiiInputTableData(datas);
      prevDatasRef.current = datas;
    }
  }, [columns, datas, setNiiInputTablecolumn, setNiiInputTableData]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} lg={12}>
        <ColumnGroupingTable
          columns={columns}
          datas={datas}
          loading={false}
          disablePagination={true}
          applyThousandsSeparator={true}
          freezeParentColumnCount={2}
          tableHeight={350}
          rowSpanKey="type"
        />
      </Grid>
    </Grid>
  );
};

export default NiiInputTable;
